export enum LorenMenuItemType {
  LINK,
  BUTTON,
  SUBHEADER,
  DIVIDER,
}
